export const productName = 'MEGAPACK GESTIÓN AMBIENTAL LISTO';
export const productShortName = 'Megapack Gestión Ambiental Listo';
export const productImage = 'https://cdn.magicpatterns.com/uploads/dQZj7TpHmr3Zo5LGYkxNkH/MOCKUP_5.56.34_p._m..png';

export const checkoutUrl = 'https://megapack-gestion-ambiental-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de la Gestión Ambiental',
  'Tomo 2 — Recursos Naturales y Gestión Sostenible',
  'Tomo 3 — Aspectos, Impactos y Riesgos Ambientales',
  'Tomo 4 — Gestión del Agua, Suelo y Contaminación',
  'Tomo 5 — Gestión de Residuos y Economía Circular',
  'Tomo 6 — Biodiversidad, Ecosistemas y Conservación',
  'Tomo 7 — Cambio Climático y Desafíos Ambientales',
  'Tomo 8 — Sistemas de Gestión Ambiental y Mejora Continua',
  'Tomo 9 — Enseñanza de la Gestión Ambiental: Planificación y Proyectos 2026',
  'Bono 1 — 150 Actividades de Gestión Ambiental',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos Prácticos',
  'Bono 4 — 100 Proyectos Ambientales',
  'Bono 5 — 100 Estrategias de Gestión Institucional',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de actividades sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de gestión ambiental complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la gestión ambiental',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
